import {
  ScoutJobDetailResponse,
  JobDetailResponse,
} from '@doda/api-client/aspida/@types';

/**
 * 渡されたjobオブジェクトがスカウト求人詳細か通常の求人詳細あるかどうかをチェックする。
 *
 * @param {ScoutJobDetailResponse | JobDetailResponse} 求人詳細APIの返却値かスカウト求人詳細の返却値
 * @param {boolean} isScout - スカウト求人かどうか
 * @returns {boolean} - jobがスカウト求人詳細である場合はtrue、通常の求人詳細の場合はfalseを返す
 */
export const isScoutJobDetailResponse = (
  job: ScoutJobDetailResponse | JobDetailResponse,
  isScout: boolean
): job is ScoutJobDetailResponse => {
  return isScout;
};
